import NotTakingReportCreate from "./NotTakingReportCreate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "notTakingReports",
  create: NotTakingReportCreate,
};
